import styled from 'styled-components'

import ActionHeader from '@/utilities/client-components/components/ActionHeader/ActionHeader'
import WarningPulldown from '@/utilities/client-components/components/WarningPulldown'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledDetailWrapper = styled.div`
  background-color: ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'background')};
  box-shadow: 0 3px 6px 2px rgb(100 100 100 / 50%);
  position: fixed;
  border-top: ${(props: any) =>
    props.priority ? `5px solid ${themeUtilities.getRgbaColor(props.theme, `priority.${props.priority}`)}` : 'none'};
`
const StyledInnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const StyledScroller = styled.div`
  overflow-x: hidden;
  overflow-y: ${(props: any) => (props.allowScroll ? 'scroll' : 'hidden')};
  flex: 1;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 3rem;
`

const StyledActionHeader = styled(ActionHeader)`
  background-color: ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'background')};
  border-bottom: 1px solid ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'light')};
  z-index: ${({ theme }: any) => theme.baseZ + 3};
  padding: 0.85rem;

  svg {
    margin-left: auto;
  }

  h1 {
    color: ${({ theme, rootContainer }: any) => themeUtilities.getColor(theme, rootContainer, 'dark')};
  }
`

const StyledWarningPulldown = styled(WarningPulldown)`
  z-index: ${({ theme }: any) => theme.baseZ + 2};
`

interface DetailWrapperProps {
  allowScroll?: boolean
  card?: object
  children?: React.ReactNode
  className?: string
  containerStyle?: string
  currentNotification?: object
  headerActions?: React.ReactNode
  onHideDetail?(...args: unknown[]): unknown
  renderArrow?(...args: unknown[]): unknown
  rootContainer?: string
  showClose?: boolean
  showCloseIcon?: boolean
  showDeletedWarning?: boolean
  title?: string
  visible?: boolean
}

const DetailWrapper = ({
  allowScroll,
  onHideDetail,
  currentNotification,
  card,
  className,
  showClose,
  showCloseIcon,
  renderArrow,
  title,
  children,
  showDeletedWarning,
  headerActions,
  rootContainer,
  visible
}: DetailWrapperProps) => {
  // Title can come from many places
  let resultTitle = ''
  // @ts-expect-error
  if (currentNotification && currentNotification.title) {
    // @ts-expect-error
    resultTitle = currentNotification.title
  }
  // @ts-expect-error
  if (card && card.title) {
    // @ts-expect-error
    resultTitle = card.title
  }
  if (title) {
    resultTitle = title
  }

  const showActionHeader = showClose || headerActions

  return (
    // @ts-expect-error
    <StyledDetailWrapper className={className} rootContainer={rootContainer} aria-hidden={!visible}>
      {renderArrow?.() as any}
      <StyledInnerWrap>
        {showActionHeader && (
          <StyledActionHeader
            title={resultTitle}
            onAction={onHideDetail}
            titleSize={'large'}
            // @ts-expect-error
            icon={showCloseIcon ? 'icon-cross' : null}
            rootContainer={rootContainer}
          >
            {headerActions}
          </StyledActionHeader>
        )}
        <StyledWarningPulldown label={'This notification has been deleted'} show={showDeletedWarning} />
        {/* @ts-expect-error */}
        <StyledScroller allowScroll={allowScroll}>{children}</StyledScroller>
      </StyledInnerWrap>
    </StyledDetailWrapper>
  )
}

DetailWrapper.displayName = 'DetailWrapper'

DetailWrapper.defaultProps = {
  allowScroll: true,
  showClose: true,
  showCloseIcon: true,
  onHideDetail: () => {},
  renderArrow: () => {},
  rootContainer: 'default',
  visible: true // Default to true for backward compatibility
}

export default DetailWrapper
